<template>
  <GuestListView 
    :guests="guests" 
    :is-refreshing="isRefreshing"
    @check-in="handleCheckIn"
    @reset-guest="handleResetGuest"
    @delete-guest="handleDeleteGuest"
    @refresh="loadGuests"
  />
</template>

<script>
import { ref, onMounted } from 'vue'
import GuestListView from './GuestListView.vue'
import { GuestService } from '../services/guestService.js'

export default {
  name: 'HomeView',
  components: {
    GuestListView
  },
  emits: ['check-in', 'reset-guest', 'delete-guest'],
  setup(props, { emit }) {
    const guests = ref([])
    const guestService = new GuestService()
    const isRefreshing = ref(false)

    const loadGuests = async () => {
      try {
        isRefreshing.value = true
        await guestService.loadGuests()
        guests.value = guestService.getGuests()
        
        // Show success notification
        showRefreshSuccess()
      } catch (error) {
        console.error('Error refreshing guests:', error)
      } finally {
        isRefreshing.value = false
      }
    }

    const showRefreshSuccess = () => {
      // Create a simple success notification
      const notification = document.createElement('div')
      notification.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 transition-opacity duration-300'
      notification.textContent = 'Guest list refreshed successfully!'
      document.body.appendChild(notification)
      
      // Remove after 2 seconds
      setTimeout(() => {
        notification.style.opacity = '0'
        setTimeout(() => {
          document.body.removeChild(notification)
        }, 300)
      }, 2000)
    }

    const handleCheckIn = async (guest) => {
      const result = await guestService.checkInGuest(guest)
      guests.value = guestService.getGuests()
      emit('check-in', result)
    }

    const handleResetGuest = async (guest) => {
      const result = await guestService.resetGuest(guest)
      guests.value = guestService.getGuests()
      emit('reset-guest', result)
    }

    const handleDeleteGuest = async (guest) => {
      if (!confirm(`Gast "${guest.firstName} ${guest.lastName}" wirklich löschen?`)) return
      const result = await guestService.deleteGuest(guest)
      guests.value = guestService.getGuests()
      emit('delete-guest', result)
    }

    onMounted(() => {
      loadGuests()
    })

    return {
      guests,
      handleCheckIn,
      handleResetGuest,
      handleDeleteGuest,
      loadGuests,
      isRefreshing
    }
  }
}
</script>
